import dayjs from "dayjs";

export const selectedTimeRightISO = (timeString: any) => {
  if (!timeString) return null;

  const todayDate = dayjs().format("YYYY-MM-DD");
  const combinedDateTimeString = `${todayDate}T${timeString}`;
  return combinedDateTimeString;
};

export const formatDate = (dateString: string): { formattedDate: string, formattedTime: string } => {
  const date = new Date(dateString);
  const options :any = { year: 'numeric', month: 'long', day: 'numeric' };
  const formattedDate = date.toLocaleDateString('fr-FR', options);
  const formattedTime = date.toLocaleTimeString('fr-FR', { hour: '2-digit', minute: '2-digit' });

  return { formattedDate, formattedTime };
};

export const calculateFinalTime = (
  isValidTime: boolean,
  combinedDateTime: dayjs.Dayjs,
  combinedDateTime2: dayjs.Dayjs,
  selectedTimee: dayjs.Dayjs,
  prepdate: number,
  selectedTimeRight:string
): dayjs.Dayjs => {
    const todayDate = dayjs().format("YYYY-MM-DD");
    const currentDateTime = dayjs();
    const selectedDateTime = dayjs(`${todayDate}T${selectedTimeRight}`);

  let value: dayjs.Dayjs;

  // Set value based on validity of time
  if (isValidTime) {
    value = combinedDateTime;
  } else {
    value = combinedDateTime2;
  }

  // Check if the current time is after the selected time or if selected time is too early
  if (
    currentDateTime.isAfter(selectedDateTime) ||
    selectedDateTime.format("HH:mm") <
      currentDateTime.add(prepdate, "minute").format("HH:mm")
  ) {
    value = currentDateTime.add(prepdate, "minute");
  } else {
    value = selectedTimee;

    // Compare selected time with combinedDateTime2
    if (selectedTimee.format("HH:mm") > combinedDateTime2.format("HH:mm")) {
      console.log("true is bigger");
      value = currentDateTime.add(prepdate, "minute");
    } else {
      console.log("false is less");
      value = selectedTimee;
    }
  }

  return value;
};

export const isTimeWithinRange = (newValue: any, min: string, max: string): boolean => {
  const selectedHours = newValue.hour();
  const selectedMinutes = newValue.minute();
  const selectedTotalMinutes = selectedHours * 60 + selectedMinutes;

  const [minHours, minMinutes] = min.split(":").map(Number);
  const minTotalMinutes = minHours * 60 + minMinutes;

  const [maxHours, maxMinutes] = max.split(":").map(Number);
  const maxTotalMinutes = maxHours * 60 + maxMinutes;

  return selectedTotalMinutes >= minTotalMinutes && selectedTotalMinutes <= maxTotalMinutes;
};